"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as a } from "react/jsx-runtime";
import { useTheme as n } from "../../hooks.js";
import { useIsInverseOrMediaVariant as h } from "../../theme-variant-context.js";
import { vars as c } from "../../skins/skin-contract.css-mistica.js";
const s = (_param)=>{
    var { color: l, size: e = 24 } = _param, r = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const i = h(), t = l !== null && l !== void 0 ? l : i ? c.colors.inverse : c.colors.neutralHigh, { skinName: o } = n();
    return o.match(/^blau/i) ? /* @__PURE__ */ a("svg", _object_spread_props(_object_spread({
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, r), {
        children: /* @__PURE__ */ a("path", {
            fill: t,
            d: "M6.636 8.33a5.34 5.34 0 0 0 5.336 5.337 5.34 5.34 0 0 0 5.336-5.336 5.34 5.34 0 0 0-5.336-5.337 5.34 5.34 0 0 0-5.336 5.337m1.354 0a3.987 3.987 0 0 1 3.982-3.98 3.986 3.986 0 0 1 3.982 3.98 3.986 3.986 0 0 1-3.982 3.982A3.987 3.987 0 0 1 7.99 8.331M1.976 21.384h1.355l-.001-2.14.002-.079-.001-.028a.6.6 0 0 1 .039-.182.9.9 0 0 1 .325-.467l.049-.042c.879-.808 3.072-1.498 5.646-1.783l2.573 2.93 2.711-2.931c2.53.28 4.632.955 5.534 1.784l.049.042a.94.94 0 0 1 .364.65v2.237h1.355v-2.22c0-.199-.034-.403-.096-.587a2.25 2.25 0 0 0-.778-1.14c-1.19-1.076-3.604-1.86-6.631-2.15l-.334-.031-2.148 2.323-2.041-2.324-.344.033c-3.068.293-5.588 1.097-6.754 2.15a2.24 2.24 0 0 0-.773 1.12 2 2 0 0 0-.101.606z"
        })
    })) : o.match(/^o2-new/i) ? /* @__PURE__ */ a("svg", _object_spread_props(_object_spread({
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, r), {
        children: /* @__PURE__ */ a("path", {
            fill: t,
            d: "M18.482 8.604a6.63 6.63 0 0 1-2.987 5.55C19.33 15.204 22 17.948 22 21.247a.75.75 0 0 1-.74.754.75.75 0 0 1-.74-.754c0-3.328-3.821-6.038-8.52-6.038s-8.52 2.71-8.52 6.038a.75.75 0 0 1-.74.754.75.75 0 0 1-.74-.754c0-3.3 2.67-6.043 6.505-7.091a6.63 6.63 0 0 1-2.987-5.551C5.518 4.96 8.425 2 12 2s6.482 2.961 6.482 6.604M12 3.507c-2.76 0-5.002 2.285-5.002 5.097 0 2.807 2.242 5.092 5.002 5.092s5.002-2.28 5.002-5.092S14.76 3.507 12 3.507"
        })
    })) : o.match(/^o2/i) ? /* @__PURE__ */ a("svg", _object_spread_props(_object_spread({
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, r), {
        children: /* @__PURE__ */ a("path", {
            fill: t,
            d: "M18.482 8.604a6.63 6.63 0 0 1-2.987 5.55C19.33 15.204 22 17.948 22 21.247a.75.75 0 0 1-.74.754.75.75 0 0 1-.74-.754c0-3.328-3.821-6.038-8.52-6.038s-8.52 2.71-8.52 6.038a.75.75 0 0 1-.74.754.75.75 0 0 1-.74-.754c0-3.3 2.67-6.043 6.505-7.091a6.63 6.63 0 0 1-2.987-5.551C5.518 4.96 8.425 2 12 2s6.482 2.961 6.482 6.604M12 3.507c-2.76 0-5.002 2.285-5.002 5.097 0 2.807 2.242 5.092 5.002 5.092s5.002-2.28 5.002-5.092S14.76 3.507 12 3.507"
        })
    })) : /* @__PURE__ */ a("svg", _object_spread_props(_object_spread({
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, r), {
        children: /* @__PURE__ */ a("path", {
            fill: t,
            d: "M11.999 2.25c3.342 0 5.25 1.839 5.25 5.25s-1.908 5.25-5.25 5.25c-3.259 0-5.154-1.748-5.246-4.997L6.749 7.5l.004-.253c.092-3.25 1.987-4.997 5.246-4.997m0 1.5c-2.526 0-3.75 1.18-3.75 3.75s1.224 3.75 3.75 3.75 3.75-1.18 3.75-3.75-1.224-3.75-3.75-3.75M16.188 14.255h-8.42a4.517 4.517 0 0 0-4.518 4.518v2.223c0 .414.335.75.749.75h16a.75.75 0 0 0 .742-.648l.007-.11-.041-2.229c0-2.481-2.023-4.504-4.519-4.504m-8.42 1.498h8.42a3.02 3.02 0 0 1 3.016 2.843l.032 1.651H4.748v-1.474a3.02 3.02 0 0 1 3.02-3.02"
        })
    }));
}, p = s;
export { p as default };
